export default __webpack_public_path__ + "static/media/book-main@2x.972dc8c5.png";